export const PLANS_URL = 'https://me.baole.space/plans'

/** Remembers which messages are plan refusals, so any error render can add an upgrade link. */
const upgradeLinks = new Map<string, string>()

export const toPlansUrl = (url: unknown): string => {
  if (typeof url !== 'string' || !url) return PLANS_URL
  return url.replace(/\/+$/, '').endsWith('/plans') ? url : `${url.replace(/\/+$/, '')}/plans`
}

export const upgradeUrlFor = (message?: string | null): string | null =>
  (message && upgradeLinks.get(message)) || null

/** An error answer from the LightScape API, with the server's own sentence. */
export class ApiError extends Error {
  readonly status: number
  readonly code?: string
  readonly upgradeUrl?: string
  readonly body: Record<string, unknown>

  constructor(status: number, message: string, body: Record<string, unknown> = {}) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.body = body
    this.code = typeof body.code === 'string' ? body.code : undefined
    const isPlanRefusal = this.code === 'PLAN_LIMIT' || this.code === 'QUOTA_EXCEEDED'
    this.upgradeUrl = isPlanRefusal ? toPlansUrl(body.upgradeUrl) : undefined
    if (this.upgradeUrl) upgradeLinks.set(message, this.upgradeUrl)
  }

  get isPlanRefusal(): boolean {
    return Boolean(this.upgradeUrl)
  }

  static async from(res: Response, method: string, path: string): Promise<ApiError> {
    const text = await res.text().catch(() => '')
    let body: Record<string, unknown> = {}
    try {
      body = JSON.parse(text) as Record<string, unknown>
    } catch {
      /* not JSON */
    }
    const raw = body.message
    const message = Array.isArray(raw)
      ? raw.join('; ')
      : typeof raw === 'string' && raw
        ? raw
        : res.status === 401
          ? 'Your session expired. Sign in again.'
          : res.status >= 500
            ? 'LightScape had a problem finishing that. Please try again.'
            : `${method} ${path} failed (${res.status})`
    return new ApiError(res.status, message, body)
  }
}

export const errorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error)
